<template>
<div class="boxHome">
    <div>
        <cus-bread title="天津新东方萌新员工手册"></cus-bread>
        <router-link to='/humanDirectory'><img src="../assets/manpower.png" alt=""></router-link>
        <router-link to='/FinanceHome'><img src="../assets/financial.png" alt=""></router-link>
        <router-link to='/assetHome'><img src="../assets/asset.png" alt=""></router-link>
        <router-link to="/AdministrativeHome"><img src="../assets/administrative.png" alt=""></router-link>
        <router-link to="/appendix"><img src="../assets/appendix.png" alt=""></router-link>
        <!-- <router-link to="/appendix"> -->
            <img src="../assets/xian.png" alt="">
        <!-- </router-link> -->
        <a href="http://tj.xdf.cn/zhuanti/gzh/index.html"><img src="../assets/ma.png" alt=""></a>
            
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
        };
    },
    methods: {

    },
    mounted() {
    }
};
</script>

<style scoped>
.boxHome {
    width: 100%;
    height: 100%;
}

img {
    width: 94%;
    display: block;
    margin: 0.9rem auto 0;
}
._images_title {
    width: 100%;
    height: 100%;
    display: block;
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue